import { create } from "zustand";

// مقداردهی اولیه مستقیم از localStorage برای جلوگیری از هرگونه ناهماهنگی در لود اولیه
const initialAccess = localStorage.getItem("accessToken");
const initialRefresh = localStorage.getItem("refreshToken");
const initialRole = localStorage.getItem("role");
let initialUser = null;
try {
  const cachedUser = localStorage.getItem("user");
  if (cachedUser) initialUser = JSON.parse(cachedUser);
} catch (e) {
  console.error("Error parsing user on store init", e);
}

export const useAuthStore = create((set) => ({
  user: initialUser,
  accessToken: initialAccess || null,
  refreshToken: initialRefresh || null,
  role: initialRole || null,
  mustSetPassword: initialUser?.must_set_password || false,
  isAuthenticated: !!initialAccess, // اگر توکن وجود داشت وارد شده است

  setAuth: ({ access, refresh, user }) => {
    localStorage.setItem("accessToken", access);
    localStorage.setItem("refreshToken", refresh);
    localStorage.setItem("role", user.role || "");
    localStorage.setItem("user", JSON.stringify(user));

    set({
      user,
      accessToken: access,
      refreshToken: refresh,
      role: user.role,
      mustSetPassword: user.must_set_password || false,
      isAuthenticated: true,
    });
  },

  passwordSetSuccess: () => {
    const cachedUser = localStorage.getItem("user");
    if (cachedUser) {
      const parsedUser = JSON.parse(cachedUser);
      parsedUser.must_set_password = false;
      localStorage.setItem("user", JSON.stringify(parsedUser));
      set((state) => ({
        mustSetPassword: false,
        user: { ...state.user, must_set_password: false }
      }));
    } else {
      set({ mustSetPassword: false });
    }
  },

  logout: () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("role");
    localStorage.removeItem("user");

    set({
      user: null,
      accessToken: null,
      refreshToken: null,
      role: null,
      isAuthenticated: false,
      mustSetPassword: false,
    });

    // رفرش کردن صفحه برای پاکسازی کامل داده‌های سبد خرید کاربر قبلی از کش و رم مرورگر
    window.location.href = "/";
  },

  hydrate: () => {
    const access = localStorage.getItem("accessToken");
    const refresh = localStorage.getItem("refreshToken");
    const role = localStorage.getItem("role");
    const userStr = localStorage.getItem("user");

    if (access && refresh) {
      let user = null;
      let mustSetPassword = false;
      try {
        if (userStr) {
          user = JSON.parse(userStr);
          mustSetPassword = user.must_set_password || false;
        }
      } catch (e) {
        console.error("Error parsing user from localStorage", e);
      }

      set({
        accessToken: access,
        refreshToken: refresh,
        role,
        user,
        mustSetPassword,
        isAuthenticated: true,
      });
    }
  },
}));
